import { all, call, takeEvery, fork } from "redux-saga/effects";
import newRequestFunction from "../Utils/newSGF";

import {
  PA_FETCH_ALL_TRAINERS,
  PA_FETCH_TRAINER_BY_ID,
  PHYSICALLY_APPROVE_TRAINER,
  EXPORT_PHYSICALLY_APPROVED_TRAINERS
} from "../ActionTypes";

import {
  paFetchAllTrainersFailure,
  paFetchAllTrainersSuccess,

  paFetchTrainerByIdSuccess,
  paFetchTrainerByIdFailure,

  physicallyApproveTrainerSuccess,
  physicallyApproveTrainerFailure,

  exportPhysicallyApprovedTrainersSuccess,
  exportPhysicallyApprovedTrainersFailure,
} from "../Actions";

import {
  paGetAllTrainers,
  paGetTrainerById,
  physicalVerification,
  exportVirtuallyApprovedTrainersApi
} from "../Api";


// Requests
const paGetAllTrainersRequest = function* ({ payload }) {
  yield call(newRequestFunction, paFetchAllTrainersSuccess, paFetchAllTrainersFailure, paGetAllTrainers, payload)
}

const paGetTrainerByIdRequest = function* ({ payload }) {
  yield call(newRequestFunction, paFetchTrainerByIdSuccess, paFetchTrainerByIdFailure, paGetTrainerById, payload )
}

const physicalVerificationRequest = function* ({ payload }) {
  yield call(newRequestFunction, physicallyApproveTrainerSuccess, physicallyApproveTrainerFailure, physicalVerification, payload)
}

const exportPhysicallyApprovedTrainersRequest = function* ({ payload }) {
  yield call(newRequestFunction, exportPhysicallyApprovedTrainersSuccess, exportPhysicallyApprovedTrainersFailure, exportVirtuallyApprovedTrainersApi, payload)
}

// Watchers
const paGetAllTrainersWatcher = function* () {
  yield takeEvery(PA_FETCH_ALL_TRAINERS, paGetAllTrainersRequest)
}

const paGetTrainerByIdWatcher = function* () {
  yield takeEvery(PA_FETCH_TRAINER_BY_ID, paGetTrainerByIdRequest)
}

const physicalVerificationWatcher = function* () {
  yield takeEvery(PHYSICALLY_APPROVE_TRAINER, physicalVerificationRequest)
}

const exportPhysicallyApprovedTrainersWatcher = function* () {
  yield takeEvery(EXPORT_PHYSICALLY_APPROVED_TRAINERS, exportPhysicallyApprovedTrainersRequest)
}

export default function* rootSaga() {
  yield all([
    fork(paGetAllTrainersWatcher),
    fork(paGetTrainerByIdWatcher),
    fork(physicalVerificationWatcher),
    fork(exportPhysicallyApprovedTrainersWatcher)
  ])
}